export enum MOTIV_RESULT_TYPE {
  OFFER = 'Offer',
  DECLINE = 'Decline',
  NO_QUOTE = 'NoQuote',
  ALTERNATE = 'Alternate',
  COUNTER_OFFER = 'CounterOffer',
  SPECIALIST_OFFER = 'SpecialistOffer',
  CALCULATOR = 'Calculator',
  PROCESSING = 'Processing',
  REFERRED = 'Referred',
  RECOMMENDED = 'Recommended',
  NOT_AVAILABLE = 'NotAvailable',
  ACCEPTED = 'Accepted',
  NOT_APPROVED = 'NotApproved',
  CONDITIONAL_OFFER = 'ConditionalOffer',
}
